import React, { useState } from 'react';
import './CalculatorPage.css';

function LuckyDatesForEvents() {
  const [eventDate, setEventDate] = useState('');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const calculateLuckyDate = (dateString) => {
    // Placeholder for Lucky Dates for Events calculation logic
    // This is a simplified example; real calculation would be more complex.
    const digitsOnly = dateString.replace(/\D/g, '');

    if (digitsOnly.length !== 8) {
      return null; // Invalid length
    }

    let sum = 0;
    for (let i = 0; i < digitsOnly.length; i++) {
      sum += parseInt(digitsOnly[i], 10);
    }

    while (sum > 9) {
      sum = sum.toString().split('').reduce((s, d) => s + parseInt(d, 10), 0);
    }

    // Example: If the reduced number is 3, 6, or 9, it's considered lucky
    if (sum === 3 || sum === 6 || sum === 9) {
      return `The numerological value for this date is ${sum}, which is considered lucky for events.`;
    } else {
      return `The numerological value for this date is ${sum}. This date has a neutral influence.`;
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setResult(null);

    const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/;
    if (!dateRegex.test(eventDate)) {
      setError('Please enter a valid date in DD/MM/YYYY format.');
      return;
    }

    const calculated = calculateLuckyDate(eventDate);
    if (calculated === null) {
      setError('Invalid date. Please check your input.');
    } else {
      setResult(calculated);
    }
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Lucky Dates for Events Calculator",
    "description": "Find lucky dates for important events using numerology.",
    "url": "https://www.yourwebsite.com/lucky-dates-for-events",
    "potentialAction": {
      "@type": "CalculateAction",
      "name": "Calculate Lucky Date",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://www.yourwebsite.com/lucky-dates-for-events?date={eventDate}",
        "actionPlatform": [
          "http://schema.org/DesktopWebPlatform",
          "http://schema.org/MobileWebPlatform"
        ]
      },
      "query-input": "required name=eventDate"
    }
  };

  return (
    <div className="calculator-page container my-8">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <h1 className="text-center text-primary">Lucky Dates for Events</h1>
      <p className="text-center">Enter a date to check its numerological suitability for important events.</p>

      <form onSubmit={handleSubmit} className="calculator-form shadow-md rounded-lg p-6">
        <div className="form-group">
          <label htmlFor="eventDate">Date of Event (DD/MM/YYYY):</label>
          <input
            type="text"
            id="eventDate"
            className="form-control"
            value={eventDate}
            onChange={(e) => setEventDate(e.target.value)}
            placeholder="e.g., 29/07/2025"
            maxLength="10"
          />
        </div>
        {error && <p className="error-message">{error}</p>}
        <button type="submit" className="btn btn-primary">Check Date</button>
      </form>

      {result !== null && (
        <div className="result-section text-center my-8 p-6 shadow-md rounded-lg">
          <h2>Result:</h2>
          <p className="result-explanation">{result}</p>
        </div>
      )}
    </div>
  );
}

export default LuckyDatesForEvents;
